<div class="position-relative h-100">
  <ng-container>
    @if (variant === 'card') {
      <wl-commodity-offer-card
        [offer]="offer"
        [showLoadingState]="showLoadingState"
      >
        <div class="mb-2">
          <ed-commodity-offer-header
            [duration]="offer?.durationTitle"
            [productTitle]="offer?.productTitle"
            [productSubTitle]="offer?.productSubtitle"
            [incentive]="offer?.incentiveTitle"
            [highlight]="offer?.isHighlightedLabel"
            [showPriceTag]="false"
            [floatingHighlight]="false"
          ></ed-commodity-offer-header>
        </div>
        <div class="d-flex flex-column flex-grow-1">
          <ng-container *ngTemplateOutlet="offerBody"></ng-container>
        </div>
      </wl-commodity-offer-card>
    }

    @if (variant === 'accordion') {
      <wl-commodity-offer-accordion
        [opened]="active"
        [showLoadingState]="showLoadingState"
        [offer]="offer"
      >
        <ng-template #accordionHeader let-collapsed="collapsed">
          <ed-commodity-offer-header
            [duration]="offer?.durationTitle"
            [highlight]="offer?.isHighlightedLabel"
            [incentive]="offer?.incentiveTitle"
            [price]="offer?.expectedMonthlyAmount"
            [priceDurationLabel]="content?.priceDurationLabel"
            [productSubTitle]="offer?.productSubtitle"
            [productTitle]="offer?.productTitle"
            [isDynamicProduct]="offer?.isDynamicProduct"
            [dynamicPricingTitle]="offer?.dynamicPricingTitle"
            [showPriceTag]="true"
            [floatingHighlight]="false"
            [floatingIncentive]="false"
          ></ed-commodity-offer-header>
        </ng-template>
        <ng-template #accordionBody>
          <ng-container *ngTemplateOutlet="offerBody"></ng-container>
        </ng-template>
      </wl-commodity-offer-accordion>
    }
  </ng-container>
</div>

<ng-template #offerBody>
  @if (offer) {
    <div class="mb-3">
      <span class="gray-text text-decoration-line-through">
        @if (offer.incentiveId) {
          {{ offer.beforeDiscountExpectedMonthlyAmount | roundedCurrency }}
        }
        @if (!offer.incentiveId && ensureHorizontalAlignment) {
          <div class="mt-3"></div>
        }
      </span>

      <div wlAutomationId="offer-budget-bill-amount-section">
        <span class="h1 text-brand">
          {{ offer.expectedMonthlyAmount | roundedCurrency }}
        </span>
        <span class="lh-sm">{{ content?.priceDurationLabel }}</span>
      </div>
      @if (offer.incentiveId) {
        <div>
          <span>
            {{ content?.budgetbillAmountLabel }}
          </span>
        </div>
      }
      @if (offer.incentiveId && content?.moreInfoPriceAndConditionLinkLabel) {
        <button
          class="btn p-0 border-0 btn-link mt-1"
          (click)="openMoreInfo.emit()"
          wlAutomationId="more-info-button"
          wlCSCapture
        >
          {{ content?.moreInfoPriceAndConditionLinkLabel }}
        </button>
      }
    </div>
  }
  @if (offer) {
    <div class="mt-auto">
      @if (offer.usps) {
        <div class="mb-2">
          <wl-commodity-usp-list [usps]="offer.usps"></wl-commodity-usp-list>
        </div>
      }
      <button
        class="btn btn-sales-primary mb-2 w-100"
        (click)="selectOffer.emit()"
        wlAutomationId="offer-submit-button"
        wlCSCapture
      >
        {{ content?.offerSubmitButtonLabel }}
      </button>
      <div class="d-flex justify-content-center">
        <button
          class="btn p-0 border-0 btn-link mt-2 mb-1"
          (click)="viewTariffs.emit()"
          wlAutomationId="info-card-button"
          wlCSCapture
        >
          {{ content?.tariffModalLinkTextLabel }}
        </button>
      </div>
    </div>
  }
</ng-template>
